var React = require('react');

function NavigationMenu (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"navigation-menu"),React.createElement("rect",{"x":"0.5","y":"2.5","width":"23","height":"3","rx":"1","ry":"1","key":1}),React.createElement("rect",{"x":"0.5","y":"10.5","width":"23","height":"3","rx":"1","ry":"1","key":2}),React.createElement("rect",{"x":"0.5","y":"18.5","width":"23","height":"3","rx":"1","ry":"1","key":3})]);
}

NavigationMenu.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavigationMenu;

NavigationMenu.default = NavigationMenu;
